import { defineStore } from 'pinia';
import { fetchWrapper } from '@/helpers';
import { computed } from 'vue';
import { message } from 'ant-design-vue';

// 供应商
export const useAccountsStore = defineStore({
  id: 'accounts',
  state: () => ({
    accounts: [],
    loading: false,
    modalVisible: false,
    modalTitle: '',
    searchState: {
      pageNum: 1,
      pageSize: 10,
      username: '',
      status: 'enabled'
    },
    modalState: {
      visible: false,
      title: 'Title'
    },
    formState: {
      id: '',
      username: '',
      password: '',
      email: '',
      phone: '',
      remark: ''
    },
    pagination: {}
  }),

  getters: {
    computedPagination() {
      return computed(() => ({
        total: this.searchState.total,
        current: this.searchState.pageNum,
        pageSize: this.searchState.pageSize,
        defaultPageSize: 10,
        showTotal: total => `总共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true
      })).value;
    }
  },

  actions: {
    async fetchAll() {
      this.loading = true;
      await fetchWrapper.post(process.env.VUE_APP_API_URL + `/api/tenantAccount`, this.searchState)
      .then(
        response => response
      )
      .then(data => {
        if (data.code === 520) {
          this.accounts = data.message.data;
          this.searchState = { ...this.searchState, total: data.message.total };
          this.pagination = this.computedPagination;
        } else {
          message.error(data.message);
        }
      })
      .catch(error => console.log(error));
      this.loading = false;
    },
    async update(values) {
      await fetchWrapper.post(process.env.VUE_APP_API_URL + `/api/updateTenantAccount`, values)
      .then(
        response => response
      )
      .then(data => {
        if (data.code === 520) {
          message.success('更新成功');
          // this.accounts = data.list.data;
          // this.searchState = { ...this.searchState, total: data.list.total };
          // this.pagination = this.computedPagination;
        } else {
          message.error(data.message);
        }
      })
      .catch(error => console.log(error));
      this.loading = false;
    },

    async changeStatus(record) {
      await fetchWrapper.post(process.env.VUE_APP_API_URL + `/api/changeStatusTenantAccount`, record)
      .then(
        response => response
      )
      .then(data => {
        if (data.code === 520) {
          message.success('更新成功');
          record.status = record.status == 'enabled' ? 'disabled' : 'enabled';
          this.accounts.splice(index, 1, record);
        } else {
          message.error(data.message);
        }
      })
      .catch(error => console.log(error));
    },
  }
});